import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Video } from 'images/latest'

const VideoIcon = () => (
  <ResponsiveSVG
    width={['56px', null, '56px']}
    className='unstyled'
    svgProps={{ viewBox: '0 0 56 56' }}
    SVG={Video}
  />
)

export default VideoIcon
